<template>
    <app-main>
        <app-content>

            <div class="flex flex-wrap -mx-2">
                <div class="w-full md:w-1/2 px-2">
                    <!-- Start Title -->
                    <app-title
                        title="Forms"
                    />
                    <!-- End Title -->
                </div>
            </div>

            <app-box :loading="loading" :initial="loading">
                <select name="locations" v-model="selected" class="input mb-8">
                    <option value="general">General</option>
                    <option v-for="(l, i) in items.locations" :value="l.id" v-html="l.name" />
                </select>

                <div v-if="selected == 'general'">
                    <small class="block mb-2 italic text-center">Please note: Location specific configuration will overwrite general configuration</small>
                    <app-field-text 
                        :required="false"
                        label="To" 
                        v-model="fields.general.to" 
                        :error="errors.to"
                    />

                    <app-field-text 
                        :required="false"
                        label="CC" 
                        v-model="fields.general.cc" 
                        :error="errors.cc"
                    />

                    <app-field-text 
                        :required="false"
                        label="BCC" 
                        v-model="fields.general.bcc" 
                        :error="errors.bcc"
                    />
                </div>

                <div v-for="(location, index) in items.locations" v-if="selected == location.id">
                    <app-field-text 
                        :required="false"
                        label="To" 
                        v-model="fields[location.id].to" 
                        :error="errors.to"
                    />

                    <app-field-text 
                        :required="false"
                        label="CC" 
                        v-model="fields[location.id].cc" 
                        :error="errors.cc"
                    />

                    <app-field-text 
                        :required="false"
                        label="BCC" 
                        v-model="fields[location.id].bcc" 
                        :error="errors.bcc"
                    />
                </div>

                <div slot="footer">
                    <app-button element="a" class="btn  btn--primary  btn--primary--sml" @click="save">
                        Save
                    </app-button>

                    <app-button element="a" class="btn  btn--secondary  btn--secondary--sml ml-4" @click="$router.push({ name: 'forms.home' })">
                        Cancel
                    </app-button>
                </div>
            </app-box>
        </app-content>

        </app-content>
    </app-main>
</template>

<script>
    import { mapGetters } from 'vuex';

    /* API */
    import Api from '@/api/index.js';
    import Auth from '@/api/auth.js';

    /* Components */
    import Main from '@/components/Main';
    import Content from '@/components/template/Content';
    import Title from '@/components/Title';
    import Box from '@/components/Box';
    import Button from '@/components/Button';
    import PaginationLinks from '@/components/PaginationLinks';
    import Permissions from '@/components/Permissions';
    import TextField from '@/components/fields/inputs/Text';
    import SelectField from '@/components/fields/inputs/Select';

    /* Mixins */
    import ValidationErrors from '@/mixins/validationErrors.js';

    export default {
        name: 'forms.edit',

        props: {
            handle: {
                type: String,
                required: true
            }
        },

        data: () => ({
            loading: true,
            selected: 'general',
            fields: {
                general: {
                    to: '',
                    cc: '',
                    bcc: ''
                }
            },
            errors: {},
            items: {
                locations: []
            }
        }),

        mixins: [ ValidationErrors ],

        components: {
            'app-main': Main,
            'app-content': Content,
            'app-title': Title,
            'app-box': Box,
            'app-button': Button,
            'app-pagination-links': PaginationLinks,
            'app-field-text': TextField,
            'app-field-select': SelectField,
            'app-permissions': Permissions
        },

        mounted() {
            this.locations().then(response => {
                return this.setup();
            }).then(response => {
                this.loading = false;
            });
        },

        methods: {
            locations() {
                return Api.request('get', `forms/locations`)
                    .then(({ data }) => {
                        this.items.locations = data.locations;
                        for(let key in data.locations) {
                            this.fields[data.locations[key].id] = {
                                to: '',
                                cc: '',
                                bcc: ''
                            };
                        }
                    });
            },

            setup() {
                return Api.request('get', `forms/edit/${this.handle}`).then(({ data }) => {
                    for(let key in data.forms) {
                        const k = (data.forms[key].location_id == null) ? 'general' : data.forms[key].location_id;
                        if(typeof this.fields[k] !== 'undefined') {
                            for(let index in this.fields[k]) {
                                this.fields[k][index] = data.forms[key][index];
                            }
                        }
                    }
                });
            },

            save() {
                this.loading = true;
                this.clearErrors();

                return Api.request('post', `forms/update/${this.handle}`, this.fields).then(response => {
                    if(typeof response.data.message != 'undefined') {
                        this.$toasted.show(response.data.message, { 
                            type: "success", 
                            position: "bottom-right", 
                            duration : 5000
                        });
                    }
                    if(typeof response.data.id != 'undefined') {
                        this.$router.push({
                            name: 'forms.home'
                        });
                    }
                }).catch(error => {
                    if(this.hasErrors(error)) {
                        this.addErrors(error);
                    }
                }).then(response => {
                    this.loading = false;
                });
            },
        },
    }
</script>



// WEBPACK FOOTER //
// src/views/forms/Edit.vue